import {useContext, useState} from 'react';
import config from '../../../config';
import { compressSync, strToU8 } from "fflate";
import { bytesToBase64 } from "byte-base64";
import {OrgDataContext} from "../../../context/orgData";

const endpoint = config.manifestPrintoutEndpoint;

// const useFetchState = (defaultState={ fetching: false, error: null }) => {
//     const [fetchState, setFetchState] = useState({ fetching: defaultState.fetching, error: defaultState.error })
//     return [
//         fetchState,
//         (isFetching) => setFetchState({ ...fetchState, fetching: isFetching }),
//         (err) => setFetchState({ ...fetchState, error: err })
//     ]
// }

function useManifestPrintout(type, layout){

    const orgData = useContext(OrgDataContext);

    const url = `${endpoint}/${type}/${layout}`;

    // const [ { fetching, error }, setFetching, setError ] = useFetchState();
    const [ fetching, setFetching ] = useState(false);
    const [ error, setError ] = useState(null);

    const fetchPrintout = async function(body, autoDownload=false, fileName=null){
        setFetching(true);
        setError(null);
        var resp;

        // Compress the request body with gzip
        const buffer = strToU8(JSON.stringify(body));
        const compressed = compressSync(buffer);

        try{
            // Send request to printout microservice
            resp = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/octet-stream',
                    'X-Content-Encoding': 'gzip;base64',
                    'X-Organization-Id': orgData.getOrgIDByType('customer')
                },
                body: bytesToBase64(compressed)
            })
        }
        catch(err){
            console.error(err);
            setFetching(false);
            setError(err);
            throw err
        }
        setFetching(false);
        if (resp.ok){

            let defaultFileName = 'download.txt';

            // Get filename from content-disposition header if present
            const disposition = resp.headers.get('content-disposition');
            if (disposition && disposition.indexOf('attachment') !== -1) {
                const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                const matches = filenameRegex.exec(disposition);
                if (matches != null && matches[1]) {
                    defaultFileName = matches[1].replace(/['"]/g, '');
                }
            }

            const blob = await resp.blob();
            const objURL = URL.createObjectURL(blob);
            if (autoDownload){
                const link = document.createElement('a');
                link.href = objURL;
                link.setAttribute('download', fileName || defaultFileName);
                document.body.appendChild(link);
                link.click();
                link.parentNode.removeChild(link);
            }
            return objURL
        }
        else {
            var msg;
            try{
                const json = await resp.json();
                msg = json.Message;
            }
            catch(err){
                msg = err.message
            }
            await setError(new Error(msg))
            throw error
        }

    }

    function clearError(){
        setError(null);
    }

    return [ fetchPrintout, fetching, error, clearError ]
}

export default useManifestPrintout